// extracted by mini-css-extract-plugin
module.exports = {"block":"a10a3f92e9--block--3FRWT","title":"a10a3f92e9--title--2kmbq","description":"a10a3f92e9--description--1eDCW","button-text":"a10a3f92e9--button-text--kS0od"};